import React, { useMemo } from "react";
import { Building2, Menu } from "lucide-react";

export default function Header({ collapsed, setCollapsed }) {
    // Lấy thông tin user từ token
    const userName = "Tomotek";

    // Tạo avatar URL từ tên user
    const avatarName = useMemo(() => {
        if (!userName) return "User";
        // Lấy chữ cái đầu của từ cuối cùng trong tên
        const nameParts = userName.trim().split(/\s+/);
        return nameParts[nameParts.length - 1] || "User";
    }, [userName]);

    // Lấy tên ngắn gọn để hiển thị (từ cuối cùng trong tên)
    const displayName = useMemo(() => {
        if (!userName) return "Bạn";
        const nameParts = userName.trim().split(/\s+/);
        return nameParts[nameParts.length - 1] || "Bạn";
    }, [userName]);

    return (
        <header className="flex items-center justify-between bg-white shadow-sm px-6 py-4 h-[80px] border-b border-gray-200">
            {/* Logo + Toggle */}
            <div className="flex items-center gap-4">
                <div className="flex items-center gap-3 w-64">
                    <Building2 size={35} className="text-primary" />
                    <h1 className="text-xl font-bold text-primary tracking-wide">
                        WEBCHECK 
                    </h1>
                </div>

                <Menu
                    size={40}
                    className="text-gray-700 p-2 rounded hover:bg-primary/10 cursor-pointer transition-colors"
                    onClick={() => setCollapsed(!collapsed)}
                />
            </div>

            {/* User Info */}
            <div className="flex items-center gap-4">
                <span className="font-semibold text-gray-700">
                    Xin chào, {displayName} 👋
                </span>
                <img
                    src={`https://ui-avatars.com/api/?name=${encodeURIComponent(
                        avatarName
                    )}&background=7D7ACC&color=fff`}
                    alt="avatar"
                    className="w-10 h-10 rounded-full border-2 border-gray-200"
                />
            </div>
        </header>
    );
}
